import { ECOMMERCE_DEVELOPMENT_ROOT } from 'constants/links';
import { isDev } from '@cat-ecom/common/utils/commonUtils';
import { StringifyOptions } from 'query-string';
import { getRelativeURLWithParams } from 'utils/url';

/**
 * Adding development prefix for e-commerce links
 */
export const normalizeCommerceLink = (link: string) =>
  isDev() && !link?.startsWith(ECOMMERCE_DEVELOPMENT_ROOT)
    ? `${ECOMMERCE_DEVELOPMENT_ROOT}${link}`
    : link;

/**
 * Helper to create esite url from params with shape /{lang}/{esite}[path][?query]
 */
export const getSeoUrl = (
  params: esiteParams | Record<string, string | string[]> | null,
  path = '',
  query: Query = {},
  options: StringifyOptions = {}
) =>
  getRelativeURLWithParams(
    `/${params?.lang}/${params?.esite}${path}`,
    query,
    options
  );
